<template>
  <div>
    <img
      v-if="ChooseImageShapeActive"
      :src="ChangeImgUrl"
      class="custom-image"
      @click="onShowModal"
    />
    <button v-else type="button" @click="onShowModal" v-bind:class="{ choose_image_shape_active: ChooseImageShapeActive }" class="btn btn-upload-shape-image">
      Select image
    </button>

    <div v-if="this.BoxcontentMessageError" class="message-error-left-group">
      <div>{{contentMessageError}}</div>
    </div>

    <input
      ref="input"
      type="file"
      name="image"
      accept="image/*"
      multiple="true"
      @change="setImage"
    />
    <input
      ref="inputOne"
      type="file"
      name="image"
      accept="image/*"
      @change="setImageOne"
    />

    <modal
      :name="modalName"
      :adaptive="true"
      height="auto"
      width="800"
      @ok="onAutoFill"
      :clickToClose="true"
      :reset="true"
      class='Modal_box'
    >
      <div @click="hideModal" class="Abn-modal-close-new">&#10005;</div>
      <div class="modal-body-group">
        <div class="modal-header-control">
<!--          <i style='margin-right: 5px'>{{dataUrl.length}}/{{maxNumberImagesMulShape}} images</i>-->
          <button v-if='dataUrl.length > 0' @click='OnButtonReset' class='btn-reset'>Reset</button>
          <div v-if='status_message_error' class='message_error'>
            <i class='message_error_text' v-html="text_message"></i>
          </div>
        </div>
        <div class="box-shape-default-shape">
          <div class="box-shape-default-shape-item" v-for="(item, index) in dataUrl">
            <div class="box-shape-default-shape-content">
              <div v-if="item.img_url" class="img_url">
                <img class="img_url_class" @click="onShowAskCrop(item.img_key)" :src="item.img_url" />
              </div>
              <img v-if='!item.img_url' :src='item.url_blob' class='box-image-item' />
              <div v-if='"status" in item && item.status == false' class='bx-loading-upload'>
                <img class='img-bx-loading-upload' :src='spin_white' />
              </div>
              <div class='box-cloud-upload' v-if='item.img_url != "" ' >
                <img class='icon-cloud' :src="cloud_icon" />
              </div>
              <div class="number_item_view">{{item.img_key + 1}}</div>
              <div v-if="item.error" class="info_error_box">
                <v-icon name="info"></v-icon>
              </div>
              <div v-if='item.img_url != "" '  class='box-remove'>
                <button @click='handleRemove(item.img_key)' class='btn-remove-img'>
                  <v-icon name="trash-2"></v-icon>
                </button>
              </div>
              <div v-if='item.img_url == "" ' class="group_button">
                <button @click="ChooseImageItem(item.img_key)" class="btn-change-item-img">
                  &#10010;
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="group-button">
          <button :disabled='loading_upload'  @click="OnClickUploadFile" class='btn btn-upload-file'>
            &#10011; Upload Photos
          </button>
          <button :disabled='status_autofill' @click="OnClickAutoFill" class='btn btn-autofill'>
            &#9783; Autofill
          </button>
        </div>
      </div>
    </modal>

    <modal
      :name="modalAsk"
      :adaptive="true"
      height="auto"
      width="500"
      :clickToClose="true"
      :reset="true"
      class='Modal_ask_box'
    >
      <div class="box-modal-ask">
        <div @click="hideModalAsk" class="box-modal-ask-close">&#10005;</div>
        <p class="modal-ask-text">Please choose your action!</p>
        <div class="group_ask_button">
          <button @click="ChooseImageItem(key_active)" class='btn btn_ask_change'>
            <v-icon style="width: 20px" name="refresh-cw"></v-icon> Change
          </button>
          <button @click="onShowModalCrop(key_active)" class='btn btn_ask_edit'>
            <v-icon style="width: 20px" name="crop"></v-icon> Edit
          </button>
        </div>
      </div>
    </modal>

    <modal
      :name="modalCropName"
      :adaptive="true"
      height="auto"
      width="1000"
      @ok="onCrop"
      @cancel="handleCropCancel"
      :clickToClose="false"
      :reset="true"
      class='Modal_crop_box'
    >
      <div @click="hideModalCrop" class="Abn-modal-close">&#10005;</div>
      <div class='Abn-modal-crop'>
        <div class="modal-wrapper">
          <div class="cropper-wrapper">
            <vue-cropper
              v-if="imageCrop"
              ref="cropper"
              :src="imageCrop"
              :zoom="zoom"
            />
          </div>

        </div>
      </div>
      <div class="Modal-crop-multiple-footer">
        <div class="Abn-modal-footer-div">
          <button class="btn Abn-btn-cancel" @click="hideModalCrop">Cancel</button>
          <button  class="btn Abn-btn-apply" @click="onCrop" :disabled="loadingCrop">
            <font-awesome-icon v-if="loadingCrop" icon="spinner" class="fa-spin" />
            Apply
          </button>
          <div style="clear:both;"></div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'
import {ASSET_URL, URL_API_FILL_IMAGES_SHAPE, URL_API_FILL_IMAGES_SHAPE_V2} from '@/config.js'
import Empty from '../Utilities/Empty';
import {mapGetters, mapMutations} from 'vuex'
import { Carousel, Slide } from 'vue-carousel'
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'
import {get} from 'lodash'
import { getImageURL } from '@/helper/helper'
import {CDN_URL} from "../../config";

export default {
  name: 'ImageShapeMultiple',
  components: { Empty, Carousel,Slide,VueCropper  },
  props: {
    context: {
      type: Object,
      required: true
    },
    aspectRatio: {
      type: Number,
      default() {
        return 1
      }
    },
    shapes: {
      type: String,
      default() {
        return null
      }
    },
    name: {
      type: String,
      default(){
        return null
      }
    },
    maxNumberImagesMulShape: {
      type: Number,
      default(){
        return 10
      }
    }
  },
  data(){
    return {
      ChooseImageShapeActive: false,
      urls: [],
      dataUrl: [],
      UrlImageShape: null,
      loading_upload: false,
      messageLoading: false,
      img_loading: "https://d2xkqnccwhm2wc.cloudfront.net/images/u5TlOWQgRsGiZW5XflL1rYzDCJQmuuYR7hzF3gwV.svg",
      spin_white: "https://d2xkqnccwhm2wc.cloudfront.net/images/G5V8kO7P6l32sdRHUMjw3HQ9fMIVj1jyGknn4hy5.svg",
      text_message: 'Invalid image format!. Please choose another image.',
      status_message_error: false,
      guide_status: false,
      cloud_icon: "https://d2xkqnccwhm2wc.cloudfront.net/images/5n2zuVdOfrketzWuOk7Omn9pcq3NvYR6mU86IkMr.svg",
      status_autofill: true,
      ChangeImgUrl: null,
      activeIndex: 0,
      activeMedia: true,
      imgKeyActive: null,
      urlReturn: "",
      BoxcontentMessageError: false,
      contentMessageError: "",
      imageCrop: null,
      image_before_crop: null,
      loadingCrop: false,
      key_active: null,
      imgObjectUrl: null,
      maxImageDimension: 2500
    }
  },
  created() {
    this.UrlImageShape = ASSET_URL + '/' + this.shapes;

    for(var a=0; a<this.maxNumberImagesMulShape; a++){
      var item = {
        "img_key": a,
        "img_url": "",
        "img_location": "",
        "url_blob": "",
        "active": false
      }
      this.dataUrl = [...this.dataUrl, item]
    }
    if(localStorage.getItem(this.localStorageName)){
      const data = localStorage.getItem(this.localStorageName);
      this.dataUrl = JSON.parse(data);
    }
  },
  beforeDestroy() {
    if (this.imgObjectUrl) {
      URL.revokeObjectURL(this.imgObjectUrl)
    }
  },
  computed: {
    modalName() {
      return `multiple-${this.uniqueID(10)}`
    },
    modalAsk(){
      return `ask-${this.uniqueID(10)}`
    },
    modalCropName(){
      return `crop-${this.uniqueID(10)}`
    },
    localStorageName(){
        return this.context.name + '_' + this.product().id;
    }
  },
  watch: {
    context(value){
      const key = get(value, 'model.key', null);
      if(key && this.isSaveLocalstorage() && (key.indexOf('upload-custom') >= 0 || key.indexOf('image_shape') >= 0)){
        this.ChangeImgUrl = ASSET_URL + '/' + key;
        this.ChooseImageShapeActive = true;
      }
    },
    urls(){
      this.CheckLoad();
      let Search = this.dataUrl.find((e)=> e.active == false);
      if(Search){
        this.loading_upload = false
      }else {
        this.loading_upload = true
      }
      // if(this.dataUrl.length >= this.maxNumberImagesMulShape){
      //   this.loading_upload = true
      // }else{
      //   this.loading_upload = false
      // }
    }
  },
  methods: {
    ...mapGetters([
      'product',
      'platform',
      'getCartData',
      'isSaveLocalstorage'
    ]),
    ...mapMutations([
      'setCartDataByKey',
      'setMessageError',
      'setLoadingForm',
      'setIsSaveLocalstorage'
    ]),
    onShowModal(){
      const check = this.dataUrl.find((e) => e.active == true);
      if(check){
        this.$modal.show(this.modalName);
        this.CheckLoad();
      }else {
        this.$refs.input.click()
      }
    },
    SaveLocalStore(){
      localStorage.setItem(this.localStorageName, JSON.stringify(this.dataUrl));
    },
    HideMessageError(){
      const OnThis = this;
      setTimeout(function(){
        OnThis.status_message_error = false;
      }, 5000);
    },
    ChooseImageItem(img_key){
      this.imgKeyActive = img_key;
      this.$refs.inputOne.click();
      this.$modal.hide(this.modalAsk)
    },
    zoom(e) {
      if (e.detail.ratio > 1) {
        e.preventDefault()
      }
    },
    async CallUpload(file, id){
      var signedUrl = await this.getSignedUrl(file.type)
      const uploads = await axios
        .put(signedUrl.url, file, {
          headers: {
            'Content-Type': file.type
          }
        })
        .catch(err => console.error(err));
      if(uploads.status === 200){
        const dataUrl = this.dataUrl;
        for (var a in dataUrl){
          if(dataUrl[a].img_key == id){
            dataUrl[a].status = true;
            dataUrl[a].img_url = ASSET_URL+'/'+signedUrl.key;
            dataUrl[a].error = false;
            dataUrl[a].image_before_crop = null
          }
          this.CheckLoadingUpload();
        }
        this.dataUrl = dataUrl;
      }else {
        const dataUrl = this.dataUrl;
        for (var a in dataUrl){
          if(dataUrl[a].img_key == id){
            dataUrl[a].status = true;
            dataUrl[a].url_blob = null;
            dataUrl[a].error = true;
          }
          this.CheckLoadingUpload();
        }
        this.dataUrl = dataUrl;
      }
      this.CheckLoad();
      this.SaveLocalStore();
    },
    CheckLoad(){
      const data = this.dataUrl;
      const checkImgUrl = data.filter((e)=> e.img_url != "");
      if(checkImgUrl.length >= 1){
        this.status_autofill = false;
      }else {
        this.status_autofill = true;
      }
    },
    async getBase64FromUrl(url){
      const data = await fetch(url);
      const blob = await data.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          const base64data = reader.result;
          resolve(base64data);
        }
      });
    },
    onShowAskCrop(key){
      this.key_active = key;
      this.$modal.show(this.modalAsk)
    },
    getImageSRC(key,width = '',unit = 'px',webp = true,trim = ''){
      var data = {key, width, unit, webp, trim }
      if (webp && !window.__WEBP) {
        data.webp = false
      }
      return `${CDN_URL}/${btoa(JSON.stringify(data))}`
    },
    async urlToBlog(url){
      const res = await fetch(url)
      const blob = await res.blob()
      return this.resizeBlobForCropper(blob, this.maxImageDimension)
    },
    resizeBlobForCropper(blob, maxDimension) {
      return new Promise((resolve, reject) => {
        const sourceUrl = URL.createObjectURL(blob)
        const img = new Image()
        img.onload = () => {
          const width = img.naturalWidth
          const height = img.naturalHeight
          const scale = Math.min(1, maxDimension / Math.max(width, height))
          const canvas = document.createElement('canvas')
          canvas.width = Math.max(1, Math.round(width * scale))
          canvas.height = Math.max(1, Math.round(height * scale))
          const ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
          URL.revokeObjectURL(sourceUrl)
          const mime = blob.type === 'image/png' ? 'image/png' : 'image/jpeg'
          canvas.toBlob(
            resizedBlob => {
              if (!resizedBlob) {
                reject(new Error('Canvas toBlob failed'))
                return
              }
              resolve(URL.createObjectURL(resizedBlob))
            },
            mime,
            0.92
          )
        }
        img.onerror = () => {
          URL.revokeObjectURL(sourceUrl)
          reject(new Error('Failed to load image'))
        }
        img.src = sourceUrl
      })
    },
    async onShowModalCrop(key){
      const {dataUrl} = this
      const search = dataUrl.find((e)=> e.img_key == key);
      if(search){
        this.setLoadingForm(true);
        try{
          let url;
          if(search.image_before_crop && search.image_before_crop != null){
            url = await this.urlToBlog(search.image_before_crop);
          }else {
            const string = search.img_url;
            const key_image = string.replace(ASSET_URL + '/', '');
            const getUrl = this.getImageSRC(key_image, "", 'px', true);
            this.image_before_crop = getUrl
            url = await this.urlToBlog(getUrl);
          }
          if (this.imgObjectUrl) {
            URL.revokeObjectURL(this.imgObjectUrl)
          }
          this.imgObjectUrl = url;
          this.imageCrop = url;
          this.$modal.show(this.modalCropName);
        }catch(err){
          console.error(err);
          this.setMessageError(true);
        }
        this.setLoadingForm(false);
      }
      this.$modal.hide(this.modalAsk);
    },
    async onCrop(e){
      e.preventDefault();
      this.setLoadingForm(true);
      const getCropedCanvas = this.$refs.cropper.getCroppedCanvas().toDataURL();
      const uploadFile = await this.upload(getCropedCanvas);
      const dataUrl = this.dataUrl;
      for(var a in dataUrl){
        if(dataUrl[a].img_key == this.key_active){
          dataUrl[a].status = true;
          dataUrl[a].img_url = ASSET_URL + '/' + uploadFile.key;
          dataUrl[a].error = false;
          dataUrl[a].image_before_crop = this.image_before_crop;
        }
        this.CheckLoadingUpload()
      }
      this.dataUrl = dataUrl;
      this.CheckLoad();
      this.SaveLocalStore();
      this.$modal.hide(this.modalCropName)
      this.setLoadingForm(false);
    },
    handleCropCancel(e){
      e.preventDefault()
      this.$modal.hide(this.modalCropName)
    },
    CheckLoadingUpload(){
      let Search = this.dataUrl.find((e)=> e.active == false);
      if(Search){
        this.loading_upload = false
      }else {
        this.loading_upload = true
      }
    },
    uuidv4() {
      return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    },
    searchActive(item, urlBase64){
      let dataArr =  this.dataUrl;
      for(var a=0; a<dataArr.length; a++){
        if(dataArr[a].img_key == item.img_key){
          dataArr[a].url_blob = urlBase64;
          dataArr[a].active = true;
          dataArr[a].status = false;
        }
        this.dataUrl = dataArr;
        this.CheckLoadingUpload();
      }
    },
    async setImageOne(values){
      this.status_autofill = true;
      const files = values.target.files;
      this.loading_upload = true;
      this.setLoadingForm(true);
      for(var a=0; a<files.length; a++){
        var type = files[a].type;
        var urlBase64 = URL.createObjectURL(files[a]);
        var checkImg = type.indexOf('image');
        if(checkImg >= 0){
          var checkSvg = type.indexOf('svg');
          if(checkSvg < 0){
            let searchItem = this.dataUrl.find((e)=> e.img_key == this.imgKeyActive);
            if(searchItem){
              this.searchActive(searchItem, urlBase64);
              this.CallUpload(files[a], searchItem.img_key);
            }

          }else {
            this.status_message_error = true;
            this.text_message = "Invalid image format!. Please choose another image.";

            this.HideMessageError();
          }
        }else {
          this.status_message_error = true;
          this.text_message = "Invalid image format!. Please choose another image.";

          this.HideMessageError();
        }
      }
      values.target.value = null
      this.setLoadingForm(false);
      this.loading_upload = false;
    },
    async setImage(values){
      this.status_autofill = true;
      const files = values.target.files;
      this.loading_upload = true;
      this.setLoadingForm(true);
      this.$modal.show(this.modalName)
      for(var a=0; a<files.length; a++){
        if(this.urls.length < this.maxNumberImagesMulShape){
          var type = files[a].type;
          var urlBase64 = URL.createObjectURL(files[a]);
          var id = this.uuidv4();
          var checkImg = type.indexOf('image');
          if(checkImg >= 0){
            var checkSvg = type.indexOf('svg');
            if(checkSvg < 0){
              let searchActive = this.dataUrl.find((e)=> e.active == false);
              if(searchActive){
                this.searchActive(searchActive, urlBase64);
                this.CallUpload(files[a], searchActive.img_key);
              }
            }else {
              this.status_message_error = true;
              this.text_message = "Invalid image format!. Please choose another image.";

              this.HideMessageError();
            }
          }else {
            this.status_message_error = true;
            this.text_message = "Invalid image format!. Please choose another image.";

            this.HideMessageError();
          }
        }
      }
      values.target.value = null
      this.SaveLocalStore();
      this.setLoadingForm(false);
      this.loading_upload = false;
    },
    OnClickUploadFile(e){
      e.preventDefault();
      this.$refs.input.click()
    },
    onAutoFill(e){
      e.preventDefault();
    },
    async OnClickAutoFill() {
      const OnThis = this;
      this.setLoadingForm(true);
      let OnOk = true;

      let dataUrl = this.dataUrl;
      if(this.urlReturn != ""){
        const SearchCheckNullUrl = dataUrl.filter((element) => element.img_url == "");
        if(SearchCheckNullUrl.length >= 1){
          OnOk = false;
          let StringNumberFill = "";
          for(var k=0;k<SearchCheckNullUrl.length;k++){
            StringNumberFill += (SearchCheckNullUrl[k].img_key + 1).toString() + ", ";
          }
          this.contentMessageError = "Please select the photo in position: " + StringNumberFill + "!";
          this.BoxcontentMessageError = true;
          for (var y=0; y<dataUrl.length; y++){
            if(dataUrl[y].img_url == ""){
              dataUrl[y].error = true;
            }else {
              dataUrl[y].error = false;
            }
          }
          this.dataUrl = dataUrl;

          setTimeout(function (){
            OnThis.BoxcontentMessageError = false;
          }, 5000)
        }
      }

      if(OnOk) {
        let data = [];
        for (var a = 0; a < dataUrl.length; a++) {
          let item = {
            img_key: dataUrl[a].img_key,
            img_url: dataUrl[a].img_url,
            img_location: dataUrl[a].img_location,
          }
          data = [...data, item]
        }

        this.setCartDataByKey({
          key: this.localStorageName,
          name: this.context.label,
          value: data
        });
        try{
          const ImageShapeRawResponse = await fetch(URL_API_FILL_IMAGES_SHAPE_V2, {
            method: 'post',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              urlReturn: OnThis.urlReturn,
              urlShape: OnThis.UrlImageShape,
              urlImages: data
            })
          });
          if (ImageShapeRawResponse.ok) {
            const contentCanvas = await ImageShapeRawResponse.json();
            this.ChangeImgUrl = ASSET_URL + '/' + contentCanvas.urlReturn;
            this.urlReturn = contentCanvas.urlReturn;
            const file = {
              id: this.context.name,
              key: contentCanvas.urlReturn
            }
            let urlReturnApi = contentCanvas.urlImages;
            let dataUrlApp = this.dataUrl;
            let NewData = [];
            for (var a = 0; a < urlReturnApi.length; a++) {
              var newItem = {
                active: true,
                img_key: Number(urlReturnApi[a].img_key),
                img_location: urlReturnApi[a].img_location,
                img_url: urlReturnApi[a].img_url,
                url_blob: "",
                status: true
              }
              NewData = [...NewData, newItem];
            }
            this.dataUrl = NewData;
            this.SaveLocalStore();
            this.setIsSaveLocalstorage(true);
            this.context.model = file;
            this.ChooseImageShapeActive = true;
          }
          this.$modal.hide(this.modalName);
        }catch(err){
          this.setMessageError(true);
          this.setLoadingForm(false);
        }
      }

      this.setLoadingForm(false);

    },
    hideModal(e) {
      e.preventDefault()
      this.$modal.hide(this.modalName)
    },
    hideModalCrop(e){
      e.preventDefault()
      this.$modal.hide(this.modalCropName)
    },
    hideModalAsk(e){
      e.preventDefault()
      this.$modal.hide(this.modalAsk)
    },
    uniqueID(length) {
      var result = ''
      var chars =
        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
      for (var i = length; i > 0; --i)
        result += chars[Math.floor(Math.random() * chars.length)]
      return result
    },
    handleRemove(img_key){
      let DataUrl = this.dataUrl;
      for (var a in DataUrl){
        if(DataUrl[a].img_key == img_key){
          DataUrl[a].img_url = "";
          DataUrl[a].active = false;
          DataUrl[a].url_blob = "";
          DataUrl[a].status = true;
          DataUrl[a].image_before_crop = null
        }
        this.dataUrl = DataUrl;
      }
      // let filtered = this.urls.filter(function(value, index) {
      //   return index != name;
      // });
      // this.urls = filtered;
      this.CheckLoadingUpload();
      this.CheckLoad();
      this.SaveLocalStore();
    },
    OnButtonReset(){
      let dataUrl = this.dataUrl;
      let data = [];
      for(var a=0; a<dataUrl.length; a++){
        let item = {
          "img_key": a,
          "img_url": "",
          "img_location": dataUrl[a].img_location,
          "url_blob": "",
          "active": false
        }
        data = [...data, item];
      }
      this.dataUrl = data;
      this.urlReturn = "";
      this.CheckLoadingUpload();
      this.CheckLoad();
      this.SaveLocalStore();
    },
    async upload(base64) {
      var file = await fetch(base64)
        .then(res => res.arrayBuffer())
        .then(buf => new File([buf], 'tmp.png', { type: 'image/png' }))
      var signedUrl = await this.getSignedUrl(file.type)
      await axios
        .put(signedUrl.url, file, {
          headers: {
            'Content-Type': file.type
          }
        })
        .catch(err => console.error(err))
      return { key: signedUrl.key }
    },
    async getSignedUrl(mime) {
      var headers = new Headers()
      headers.append('Content-Type', 'application/json')
      var requestOptions = {
        method: 'GET',
        headers: headers,
        redirect: 'follow'
      }
      var signedUrl = null
      await fetch(
        `${this.$options.AWS_API}/signedUrl?type=${mime}`,
        requestOptions
      )
        .then(response => response.json())
        .then(res => (signedUrl = res))
        .catch(err => console.error(err))
      return signedUrl
    }
  }
}
</script>

<style scoped>

input[type='file'] {
  display: none;
}


.choose_image_shape_active {
  background: #26bf31 !important;
  border: 1px solid #26bf31 !important;
  animation-name: animation_button_active;
  animation-duration: 2s;
}

.Modal_box{
  overflow: auto ;
  max-width: 100%;
  margin: 0 auto;
  margin-top: 2px;
  padding: 5px;
}

.modal-body-group{
  width: 700px;
  margin: auto;
  padding-top: 50px;
  padding-bottom: 10px;
  max-width: 100%;
  position: relative;
}

.Abn-modal-close-new {
  background: #6e6e6f;
  width: 50px;
  height: 50px;
  text-align: center;
  color: white;
  font-weight: 900;
  position: absolute;
  right: 0;
  font-size: 18px;
  display: flex;
  top: 0px;
  justify-content: center;
  cursor: pointer;
  align-items: center;
  z-index: 9999999999999999999999;
}

.list-url-images{
  display: flex;
  width: 100%;
  overflow: auto;
  padding-bottom: 10px;
  flex-wrap: wrap;
  justify-content: flex-start;
  height: auto;
  max-height: 500px;
  margin-top: 15px;
}
.list-url-images::-webkit-scrollbar {
  width: 6px;
  height: 5px;
  background-color: #F5F5F5;
}

.list-url-images::-webkit-scrollbar-thumb {
  background-color: #383838;
}

.list-url-image-item{
  width: 100px;
  height: 100px;
  overflow: hidden;
  background: #e5e2e2;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5px;
  border-radius: 5px;
  /*flex-shrink: 0;*/
  position: relative;
}

.box-remove{
  position: absolute;
  bottom: 2px;
  right: 2px;
  z-index: 999999999;
}

.btn-remove-img{
  color: #1e1e1e;
  border: none;
  background: rgb(255 249 249 / 70%);
  font-size: 15px;
  border-radius: 3px;
  padding: 0;
  margin: 0;
  height: 25px;
  width: 25px;
  transition: 0.6s;
  display: none;
  min-width: 25px;
  min-height: 25px;
  max-width: 25px;
  max-height: 25px;
  line-height: 0;
  padding: 5px;
}
.btn-remove-img:hover{
  color: red;
}
.box-shape-default-shape-item:hover .btn-remove-img{
  display: block;
}

.list-url-image-item img{
  width: 100%;
}

.group-button{
  padding: 15px 0;
  margin-top: 25px;
  text-align: center;
  display: flex;
  margin: auto;
  justify-content: center;
  align-items: stretch;
  z-index: 999999999;
}

.group-button > button{
  opacity: 1;
}

.group-button > *{
  margin: 0 5px;
}

.btn-upload-file{
  border: 1px solid #d26e4b;
  width: 50%;
  background: #d26e4b !important;
  color: white;
  margin-top: 5px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
}

.btn-upload-close{
  border: 1px solid #545454;
  width: 50%;
  background: #545454 !important;
  color: white;
  margin-top: 5px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
}

.btn-autofill{
  border: 1px solid rgb(33 171 43);
  width: 50%;
  background: none 0% 0% / auto repeat scroll padding-box border-box rgb(33 171 43) !important;
  color: white;
  margin-top: 5px;
  border-radius: 3px;
}

.box-image-item {
  width: 100%;
  height: auto;
}

.message-loading-group {
  position: fixed !important;
  top: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  background: #5b5b5b87 !important;
  z-index: 9999999999999999 !important;
}

.message-loading-div {
  margin: 0 auto !important;
  width: 100% !important;
  text-align: center !important;
  position: absolute !important;
  top: 50% !important;
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}


.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.modal-header-control {
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  text-align: center;
  margin: auto;
}
button.btn-reset {
  background: #717171!important;
  padding: 0px 15px;
  color: #fff;
  font-weight: 400;
  border: none;
  border-radius: 4px;
  margin: 0;
  height: 35px;
  overflow: hidden;
  max-height: 35px;
  min-height: 35px;
  padding: 0 20px;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  transition: 0.7s;
}
button.btn-reset:hover{
  background: #d26e4b !important;
}

img.custom-image {
  width: 100px;
  height: 80px;
  object-fit: contain;
  box-shadow: rgb(0 0 0 / 20%) 0px 0px 2px 1px;
  border-radius: 3px;
  border: 3px solid var(--primary-color, #5c6ac4);
  cursor: pointer;
}

i.message_error_text {
  color: #f44336;
  font-weight: 400;
  font-size: 15px;
}

.after_header_control {
  text-align: center;
  margin: auto;
  width: fit-content;
  margin-bottom: 20px;
  position: relative;
  display: flex;
  align-items: stretch;
}

.camera_icon svg > * {
  fill: rgb(33 171 43) !important;
}

.camera_icon svg {
  width: 30px;
  height: 30px;
  margin-top: -5px;
}

.camera_text{
  font-size: 18px;
  color: rgb(33 171 43) !important;
  font-weight: 400;
}

span.guide-box {
  position: absolute;
  top: -3px;
  right: -22px;
}

.btn-guide{
  background: none;
  border: 1px solid #595959;
  padding: 0px !important;
  font-size: 12px !important;
  border-radius: 50%;
  height: 18px !important;
  cursor: pointer;
  width: 18px !important;
  color: #595959;
  font-weight: 600;
  min-width: 18px !important;
  min-height: 18px !important;
  max-width: 18px !important;
  display: flex;
  max-height: 18px !important;
  align-items: center;
  line-height: 1px !important;
  justify-content: space-around;
  margin: 0 !important;
}

.guide_group {
  position: relative;
}

.guide_text {
  position: absolute;
  width: 200px;
  background: #f6f6f6;
  top: 30px;
  right: 0;
  border-radius: 5px;
  padding: 5px;
  z-index: 9999999;
  font-size: 13px;
  box-shadow: -2px 2px 4px #607d8b;
}

.box-close-guide {
  position: absolute;
  right: -5px;
  top: -5px;
}

button.btn-close-guide {
  background: #b0b0b0;
  border: 1px solid #818181;
  padding: 0;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  font-size: 13px;
  line-height: 0;
  color: #fff;
  overflow: hidden;
  min-width: 18px;
  min-height: 18px;
  max-height: 18px;
  padding: 0;
  max-width: 18px;
  margin: 0;
}

.after_header_control> * {
  margin-left: 5px !important;
}

.box-cloud-upload {
  position: absolute;
  top: 0px;
  right: 5px;
}

.icon-cloud{
  width: 25px !important;
  height: 25px;
  padding: 0px !important;
}


img.img-bx-loading-upload {
  width: 100%;
}

.bx-loading-upload {
  z-index: 99999;
  position: absolute;
  background: #00000095;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  padding: 0px !important;
}

.box-shape-default-shape{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  max-height: 70vh;
  overflow: auto;
}

.box-shape-default-shape-item {
  width: 14%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  position: relative;
}
.box-shape-default-shape-content{
  background: #000000d1;
  position: absolute;
  top: 5px;
  left: 5px;
  right: 5px;
  bottom: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  overflow: hidden;
}

.box-shape-default-shape-item::after{
  content: "";
  display: block;
  padding-bottom: 100%;
}

.group_button {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.btn-change-item-img{
  border: none;
  background: none;
  color: #ffffff;
  font-weight: 500;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  padding: 0 !important;
  margin: 0px !important;
  margin-bottom: 0px !important;
  margin: auto !important;
}

.img_url > img {
  width: 100%;
}

.carousel_box{
  width: 90%;
  cursor: pointer;
  margin: auto;
}
.btn-toggle{
  border: none;
  font-size: 15px;
  width: 40px;
  height: 40px;
  background: none;
}
.btn-toggle > *{
  font-size: 15px
}

.img_url_class{
  cursor: pointer;
}

.number_item_view{
  position: absolute;
  bottom: 0;
  color: rgb(255 255 255 / 54%);
  left: 1px;
  background: none;
  text-align: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  font-family: monospace;
  width: 25px;
  height: 25px;
}

.info_error_box {
  position: absolute;
  bottom: 6px;
  right: 3px;
  width: 20px;
  height: 20px;
  color: red;
}

.message-error-left-group {
  position: fixed !important;
  top: 10px !important;
  right: 10px !important;
  background: #0dcaf0 !important;
  padding: 5px 25px !important;
  border-radius: 10px 0px 10px 10px !important;
  color: white !important;
  font-weight: 500 !important;
  z-index: 9999999999999999 !important;
}

/*modal crop*/
.Abn-modal-close {
  background: #6e6e6f;
  width: 50px;
  height: 50px;
  text-align: center;
  color: white;
  font-weight: 900;
  position: absolute;
  right: 0;
  font-size: 18px;
  display: flex;
  top: 0px;
  justify-content: center;
  cursor: pointer;
  align-items: center;
  z-index: 9999999999999999999999;
}

.modal-wrapper .cropper-wrapper {
  overflow: hidden;
  margin-bottom: 10px;
}
.modal-wrapper {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 100%;
  /* grid-template-rows: auto 40px; */
}

.Abn-modal-crop{
  overflow: auto ;
  width: 600px;
  max-width: 100%;
  margin: 0 auto;
  margin-top: 2px;
  padding: 5px;
}

.Abn-modal-footer{
  display: flex;
  justify-content: space-between;
}

button.btn.Abn-btn-cancel {
  background: #7b7b7e !important;
  color: white !important;
  font-weight: 600 !important;
  width: 49%;
  float: left;
}

.group_ask_button > button{
  background: #686B5A;
  color: white !important;
  font-weight: 600 !important;
  width: 49%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px;
  border-radius: 3px;
}
.group_ask_button>button > svg {
  margin-right: 5px;
}
.group_ask_button .btn_ask_edit{
  background: #d26e4b !important;
}


.group_ask_button {
  display: flex;
  justify-content: space-between;
}

.modal-ask-text{
  text-align: center;
  margin-bottom: 30px;
  margin-top: 20px;
  font-size: 17px;
}

.box-modal-ask {
  padding: 10px 20px;
  position: relative;
}

.box-modal-ask-close{
  position: absolute;
  right: 20px;
  background: #6e6e6f;
  height: 25px;
  width: 25px;
  display: flex;
  color: #ffffff;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  cursor: pointer;
  transition: 0.6s;
}
.box-modal-ask-close:hover{
  background: red;
}

button.btn.Abn-btn-apply {
  background: none 0% 0% / auto repeat scroll padding-box border-box rgb(33 171 43) !important;
  color: white !important;
  font-weight: 600 !important;
  width: 49%;
  float: left;
}

.Abn-modal-footer-div{
  width: 600px;
  max-width: 100%;
  margin: auto;
  background: #ffffff;
  padding: 10px 0;
}

.Abn-modal-footer-div > button{
  margin: 0 2px;
}

.Modal-crop-multiple-footer {
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
}

@media only screen and (max-width: 739px){
  .Modal_box{
    padding: 0px;
  }
  .group-button {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 20px;
  }
  .modal-body-group {
    padding-left: 10px !important;
    padding-right: 10px !important;
    height: 100vh;
  }
  .btn-remove-img{
    display: block;
  }
  .Abn-modal-close-new{
    width: 40px;
    height: 40px;
    z-index: 99999999;
  }

  .modal-header-control{
    top: 25px
  }
  .modal-body-group{
    padding-top: 85px;
  }
  .list-url-images{
    max-height: 85%;
    margin-top: 0px;
  }
  .box-shape-default-shape-item{
    width: 33.33%;
  }
  .box-shape-default-shape{
    padding-right: 5px;
  }
  .group-button{
    position: fixed !important;
    left: 0;
    right: 0;
    bottom: 0px;
  }
  .group-button .btn {
    font-size: 14px !important;
    padding: 5px 0;
  }

  .Modal-crop-multiple-footer {
    position: fixed;
    left: 0;
    right: 0;
    padding: 10px;
    bottom: 0px;
    padding-bottom: 0px;
  }
}

@media only screen and (max-width: 340px){
  .box-shape-default-shape-item{
    width: 50%;
  }
}

</style>

<style>
.Modal_crop_box > div  {
  overflow: auto !important;
}
.message-text-loading {
  color: #e1e1e1;
  font-weight: 500;
  text-shadow: 0px 0px 5px #0000007d;
}
.Modal_crop_box > div::-webkit-scrollbar-thumb {
  background-color: #341a1a;
}
.Modal_crop_box > div::-webkit-scrollbar {
  width: 6px;
  background-color: #F5F5F5;
}

.Modal_ask_box .vm--modal {
  top: 10px !important;
}
@media only screen and (max-width: 739px){
  .Modal_box .vm--modal {
    position: absolute !important;
    top: 0 !important;
    bottom: 0;
  }
  .Modal_crop_box .vm--modal{
    top: 0px !important;
    height: 100vh !important;
    bottom: 0 !important;
    background: white !important;
    padding: 10px;
  }
  .Abn-modal-close {
    z-index: 9999999;
    display: none !important
  }
  .Abn-modal-footer-div {
    display: flex;
  }
  .Abn-modal-footer-div > button {
    border-radius: 5px;
  }
  .Abn-modal-crop {
    margin-top: 20px !important;
  }
  .Modal_ask_box .vm--modal{
    width: 96% !important;
    margin: auto;
  }
  .Modal_ask_box .vm--modal {
    top: 30% !important;
  }
}



</style>



// WEBPACK FOOTER //
// src/components/Formulate/ImageShapeMultiple.vue